import * as Diagram from "../../../../components/diagram";

export const UnreferredList = {
  label: "未轉診名單",
  key: "UnreferredList",
  path: "FundusAbnormal/UnreferredList",
  api: "TCS_V_EyesNotVisitList02V",
  render: (options) => <Diagram.FundusAbnormal.UnreferredList {...options} />,
  isRaw: true,
  isPage: true,
  filterColumns: [
    { key: "CreateDate", type: "date" },
    { key: "RegionName", type: "string" },
  ],
  columns: [
    {
      key: "CaseID",
      field: "CaseID",
      header: "案件序號",
    },
    {
      key: "PID",
      field: "PID",
      header: "pid",
    },
    {
      key: "pName",
      field: "pName",
      header: "pname",
    },
    {
      key: "RegionName",
      field: "RegionName",
      header: "鄉鎮",
    },
    {
      key: "CreateDate",
      field: "CreateDate",
      header: "匯入日期",
    },
    {
      key: "CaseStatus",
      field: "CaseStatus",
      header: "案件狀態",
    },
  ],
};
